import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import classNames from 'classnames';

const styles = (theme) => ({
  icon: {
    color: theme.palette.xpl.text.secondary,
    marginRight: '14px',
    minWidth: 0,
    fontSize: '24px',
  },
  selected: {
    color: theme.palette.xpl.dm.primary.default,
  },
});

const MenuItemIcon = (props) => {
  const { classes, selected, Icon } = props;

  return (
    <ListItemIcon
      className={classNames(classes.icon, selected && classes.selected)}>
      {<Icon />}
    </ListItemIcon>
  );
};

MenuItemIcon.propTypes = {
  classes: PropTypes.object.isRequired,
  Icon: PropTypes.object,
  selected: PropTypes.bool,
};

MenuItemIcon.defaultProps = {
  selected: false,
  Icon: null,
};

export default withStyles(styles)(MenuItemIcon);
